// extracted by css-extract-rspack-plugin
export default {"addToCart":"AddToCartButton-module__addToCart___yt0tY"};